export const basePath = ['/cart', '/checkout', '/delivery', '/start'];
export const CHECKOUT_GENERIC_BASE_PATH = '/checkout';
export const CHECKOUT_SUBSCRIPTIONS_BASE_PATH = '/checkout/subscriptions';

const createCheckoutRoute = (basePath) => (step) => `${basePath}/${step}`;

const createCheckoutRoutes = (basePath) => (steps) =>
  steps.map((step) => ({
    step,
    path: createCheckoutRoute(basePath)(step),
  }));

const createGenericCheckoutRoute = createCheckoutRoute(CHECKOUT_GENERIC_BASE_PATH);
const createGenericCheckoutRoutes = createCheckoutRoutes(CHECKOUT_GENERIC_BASE_PATH);
const createSubscriptionCheckoutRoute = createCheckoutRoute(CHECKOUT_SUBSCRIPTIONS_BASE_PATH);
const createSubscriptionCheckoutRoutes = createCheckoutRoutes(CHECKOUT_SUBSCRIPTIONS_BASE_PATH);
export const CHECKOUT_STEPS = {
  LOGIN_OR_SIGNUP: 'login-or-signup',
  BASIC_INFO: 'basic-info',
  PRESCRIPTION_CONFIRMATION: 'verify-rx',
  SELECT_PHARMACY: 'select-pharmacy',
  RX_TRANSFER: 'transfer-rx',
  DELIVERY_ADDRESS: 'delivery-address',
  TELEHEALTH_ADDRESS: 'telehealth-address',
  ADDITIONAL_INFO: 'additional-info',
  PAYMENT_INFO: 'payment-info',
  COMMUNICATION_OPT_IN: 'phone-number',
};
const CHECKOUT_STEPS_GENERIC = Object.values(CHECKOUT_STEPS);
const CHECKOUT_STEPS_SUBSCRIPTION = [
  CHECKOUT_STEPS.LOGIN_OR_SIGNUP,
  CHECKOUT_STEPS.BASIC_INFO,
  CHECKOUT_STEPS.DELIVERY_ADDRESS,
  CHECKOUT_STEPS.ADDITIONAL_INFO,
  CHECKOUT_STEPS.COMMUNICATION_OPT_IN,
  CHECKOUT_STEPS.PAYMENT_INFO,
];
export const CHECKOUT_ROUTES = [
  ...createGenericCheckoutRoutes(CHECKOUT_STEPS_GENERIC),
  ...createSubscriptionCheckoutRoutes(CHECKOUT_STEPS_SUBSCRIPTION),
];
export const CHECKOUT_ROUTES_DELIVERY = {
  LOGIN_OR_SIGNUP: createGenericCheckoutRoute(CHECKOUT_STEPS.LOGIN_OR_SIGNUP),
  BASIC_INFO: createGenericCheckoutRoute(CHECKOUT_STEPS.BASIC_INFO),
  PRESCRIPTION_CONFIRMATION: createGenericCheckoutRoute(CHECKOUT_STEPS.PRESCRIPTION_CONFIRMATION),
  RX_TRANSFER: createGenericCheckoutRoute(CHECKOUT_STEPS.RX_TRANSFER),
  DELIVERY_ADDRESS: createGenericCheckoutRoute(CHECKOUT_STEPS.DELIVERY_ADDRESS),
  ADDITIONAL_INFO: createGenericCheckoutRoute(CHECKOUT_STEPS.ADDITIONAL_INFO),
  PAYMENT_INFO: createGenericCheckoutRoute(CHECKOUT_STEPS.PAYMENT_INFO),
  COMMUNICATION_OPT_IN: createGenericCheckoutRoute(CHECKOUT_STEPS.COMMUNICATION_OPT_IN),
};
export const CHECKOUT_ROUTES_PICKUP = {
  LOGIN_OR_SIGNUP: createGenericCheckoutRoute(CHECKOUT_STEPS.LOGIN_OR_SIGNUP),
  BASIC_INFO: createGenericCheckoutRoute(CHECKOUT_STEPS.BASIC_INFO),
  PRESCRIPTION_CONFIRMATION: createGenericCheckoutRoute(CHECKOUT_STEPS.PRESCRIPTION_CONFIRMATION),
  SELECT_PHARMACY: createGenericCheckoutRoute(CHECKOUT_STEPS.SELECT_PHARMACY),
  TELEHEALTH_ADDRESS: createGenericCheckoutRoute(CHECKOUT_STEPS.TELEHEALTH_ADDRESS),
  COMMUNICATION_OPT_IN: createGenericCheckoutRoute(CHECKOUT_STEPS.COMMUNICATION_OPT_IN),
  PAYMENT_INFO: createGenericCheckoutRoute(CHECKOUT_STEPS.PAYMENT_INFO),
};
export const CHECKOUT_ROUTES_SUBSCRIPTION = {
  LOGIN_OR_SIGNUP: createSubscriptionCheckoutRoute(CHECKOUT_STEPS.LOGIN_OR_SIGNUP),
  BASIC_INFO: createSubscriptionCheckoutRoute(CHECKOUT_STEPS.BASIC_INFO),
  DELIVERY_ADDRESS: createSubscriptionCheckoutRoute(CHECKOUT_STEPS.DELIVERY_ADDRESS),
  ADDITIONAL_INFO: createSubscriptionCheckoutRoute(CHECKOUT_STEPS.ADDITIONAL_INFO),
  COMMUNICATION_OPT_IN: createSubscriptionCheckoutRoute(CHECKOUT_STEPS.COMMUNICATION_OPT_IN),
  PAYMENT_INFO: createSubscriptionCheckoutRoute(CHECKOUT_STEPS.PAYMENT_INFO),
};
